var Vendd = (function (Vendd) {
    'use strict';

    Vendd.LoginOrder = (function (LoginOrder) {

        LoginOrder.Messages = (function (Messages) {

            Messages.ValidateLoginOrder = function (data) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LoginOrder.Messages.ValidateLoginOrder", data);
            };
            Messages.ValidateLoginOrder.className = "Vendd.LoginOrder.Messages.ValidateLoginOrder";


            Messages.ValidateLoginOrderSuccess = function (orderid) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LoginOrder.Messages.ValidateLoginOrderSuccess", orderid);
            };
            Messages.ValidateLoginOrderSuccess.className = "Vendd.LoginOrder.Messages.ValidateLoginOrderSuccess";


            Messages.ValidateLoginOrderFailure = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LoginOrder.Messages.ValidateLoginOrderFailure", data);
            };
            Messages.ValidateLoginOrderFailure.className = "Vendd.LoginOrder.Messages.ValidateLoginOrderFailure";

            Messages.ValidateLoginOrderError = function (data) {

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.LoginOrder.Messages.ValidateLoginOrderError", data);
            };
            Messages.ValidateLoginOrderError.className = "Vendd.LoginOrder.Messages.ValidateLoginOrderError";

            return Messages;

        })(LoginOrder.Messages || {});

        return LoginOrder;

    })(Vendd.LoginOrder || {});

    return Vendd;

})(Vendd || {});